var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtmLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #5af1b0;\r\n      }\r\n\r\n      .cls-2 {\r\n        filter: url(#outer-glow-1);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#51c392",
    floodOpacity: 0.81
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100,0h0c55.23,0,100,44.77,100,100h0c0,55.23-44.77,100-100,100h0C44.77,200,0,155.23,0,100H0C0,44.77,44.77,0,100,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.86,82.88c-3.02,22.56-23.95,22.33-34.65,35.35-17.91,22.33-10.7,42.09-27.44,46.51-16.74-4.42-9.53-24.42-27.44-46.75-10.23-13.25-31.4-12.79-34.19-35.58-2.33-17.21,6.74-27.91,13.95-34.65,.47-.47-4.42,16.51,3.02,26.98,6.51,8.84,24.42,13.95,33.26,20.7,10.47,8.37,11.63,17.44,11.63,17.21,.23,0,1.63-8.84,11.63-16.74,8.84-6.74,26.75-11.86,33.26-20.7,7.44-10.23,2.56-27.21,3.02-26.74,7.44,6.74,16.28,17.44,13.95,34.42Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmLogo);
export default __webpack_public_path__ + "static/media/htm-logo.245cdbb17269f74fedad2ca2758e4d34.svg";
export { ForwardRef as ReactComponent };